import styled from 'styled-components';

export const Navigation = styled.div`
	display: flex;
	height: inherit;
	position: relative;
`;

export const Wrapper = styled.div`
	flex-grow: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: auto;
`;
